import script from "./Loading.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loading.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__